import React, { Component } from "react";
import { Form, Button, Checkbox, Radio, Input } from "semantic-ui-react";
import axios from "axios";
import isEmpty from "validator/lib/isEmpty";
import matches from "validator/lib/matches";
import { connect } from "react-redux";
import InlineError from "../messages/InlineError";
import { fetchPractitionerAgreements } from "../../actions/agreementActions";

const styles = {
  checkFullnameButton: {
    cursor: "pointer",
    display: "inline-block",
    minHeight: "1em",
    outline: "0",
    border: "none",
    verticalAlign: "baseline",
    background: "#0555a2",
    color: "white",
    fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
    margin: "1em .25em 1em 0",
    padding: ".78571429em 1.5em .78571429em",
    textTransform: "none",
    textShadow: "none",
    fontWeight: "700",
    lineHeight: "1em",
    fontStyle: "normal",
    textAlign: "center",
    textDecoration: "none",
    borderRadius: ".28571429rem",
    boxShadow: "0 0 0 1px transparent inset,0 0 0 0 rgba(34,36,38,.15) inset",
    userSelect: "none",
    transition:
      "opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease",
  },
};

class EditForm extends Component {
  state = {
    data: {
      names: "",
      lastnames: "",
      fullname: "",
      gender: "",
      medical_record: "",
      phone: "",
      //se agrega para permiso de super usuario
      super_usuario:0,
      email_address: "",
      address: "",
      city: "",
      consulting_room: "",
      specialty: "",
      approved: 0,

      practitioner_id: "",
      birthdate: "",
      username: "",
    },
    agreements: [],
    showModal: false,
    policy: "",
    policy_header: "",
    isLoading: true,
    errors: {},
  };

  onChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleCheckFullname = async (id) => {
    let resp = await axios.get(`/api/practitioners/checkFullname/${id}`);
    console.log(resp);
    if (resp.data.resp) {
      this.setState({
        data: { ...this.state.data, fullname: resp.data.resp.NombreCompleto },
        errors: { ...this.state.errors, fullname: "" },
      });
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          fullname:
            "No se pudo confirmar el nombre completo como aparece en el LIS. Favor validar manualmente",
        },
      });
    }
  };

  validate = (data) => {
    const errors = {};

    if (isEmpty(data.practitioner_id))
      errors.practitioner_id = "No puede estar en blanco.";

    if (isEmpty(data.names)) errors.names = "No puede estar en blanco.";

    if (isEmpty(data.lastnames)) errors.lastnames = "No puede estar en blanco.";

    if (isEmpty(data.fullname)) errors.fullname = "No puede estar en blanco.";

    if (isEmpty(data.birthdate)) errors.birthdate = "No puede estar en blanco.";
    // if (isEmpty(data.gender)) errors.gender = "Debe elegir uno de los dos.";

    if (isEmpty(data.username)) errors.username = "No puede estar en blanco.";

    if (!matches(data.username, /^[a-z0-9\-_.]+$/i)) {
      errors.username =
        "El nombre de usuario solo puede contener letras, números o los caracteres guión ( - ), guión bajo ( _ ) o punto ( . )";
    }

    if (isEmpty(data.medical_record))
      errors.medical_record = "No puede estar en blanco.";

    if (isEmpty(data.city)) errors.city = "No puede estar en blanco.";
    if (isEmpty(data.address)) errors.address = "No puede estar en blanco.";
    if (isEmpty(data.phone)) errors.phone = "No puede estar en blanco.";
    return errors;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.props.submit(
        this.state.data,
        this.state.agreements,
        this.props.loggedPractitioner
      );
    }
  };
  _onChangeCheckbox = (e, data) => {
    const checked = data.checked ? 1 : 0;
    this.setState({
      data: { ...this.state.data, [data.name]: checked },
    });
  };
  _onChangeRadioButton = (e, data) => {
    this.setState({ data: { ...this.state.data, gender: data.value } });
  };

  _openModal = (policy) => {
    // verify that the data.agreement related to this policy is false
    if (!this.state.data[policy.name]) {
      this.setState({
        showModal: true,
        data: { ...this.state.data, [policy.name]: true },
        policy: policy.policy,
        policy_header: policy.header,
      });
    } else {
      this.setState({
        data: { ...this.state.data, [policy.name]: false },
      });
    }
  };

  _closeModal = () => {
    this.setState({
      showModal: false,
      policy: "",
      policy_header: "",
    });
  };

  componentDidMount() {
    // here must make the API Calls for agreements.
    let agreements = [];
    axios.get(`/api/agreements/MEDICO`).then((resp) =>
      this.setState({
        agreements: agreements,
        isLoading: false,
        data: {
          ...this.state.data,
          names: this.props.names,
          lastnames: this.props.lastnames,
          address: this.props.address,
          city: this.props.city,
          phone: this.props.phone,
          super_usuario: this.props.super_usuario,
          email_address: this.props.email_address,
          birthdate: this.props.birthdate,
          gender: this.props.gender,
          specialty: this.props.specialty,
          consulting_room: this.props.consulting_room,
          medical_record: this.props.medical_record,
          fullname: this.props.fullname,
          practitioner_id: this.props.practitioner_id,
          username: this.props.username,
          approved: this.props.approved,
        },
      })
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.practitioner_id !== prevProps.practitioner_id) {
      this.setState({
        isLoading: false,
        data: {
          ...this.state.data,
          names: this.props.names,
          lastnames: this.props.lastnames,
          address: this.props.address,
          city: this.props.city,
          phone: this.props.phone,
          email_address: this.props.email_address,
          birthdate: this.props.birthdate,
          gender: this.props.gender,
          specialty: this.props.specialty,
          consulting_room: this.props.consulting_room,
          medical_record: this.props.medical_record,
          fullname: this.props.fullname,
          practitioner_id: this.props.practitioner_id,
          username: this.props.username,
          approved: this.props.approved,
        },
      });
    }
  }

  onChangeCheckbox = (e, checkbox) => {
    const checked = checkbox.checked === true ? 1 : 0;
    this.setState({
      data: { ...this.state.data, approved: checked },
    });
  };

  render() {
    const {
      errors,
      data,
      agreements,
      showModal,
      policy,
      policy_header,
    } = this.state;

    return (
      <Form onSubmit={this.onSubmit}>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.practitioner_id}>
            <label htmlFor="practitioner_id">Documento de Identidad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Escriba su documento de identidad"
              id="practitioner_id"
              name="practitioner_id"
              disabled={true}
              onChange={this.onChange}
              value={data.practitioner_id}
            />
            {errors.practitioner_id && (
              <InlineError text={errors.practitioner_id} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.username}>
            <label htmlFor="username">Usuario</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="username"
              name="username"
              autoComplete="false"
              disabled={true}
              onChange={this.onChange}
              value={data.username}
            />
            {errors.username && <InlineError text={errors.username} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.names}>
            <label htmlFor="names">Nombre(s)</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="names"
              name="names"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.names}
            />
            {errors.names && <InlineError text={errors.names} />}
          </Form.Field>

          <Form.Field error={!!errors.lastnames}>
            <label htmlFor="lastnames">Apellidos</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="lastnames"
              name="lastnames"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.lastnames}
            />
            {errors.lastnames && <InlineError text={errors.lastnames} />}
          </Form.Field>
        </Form.Group>
        {this.props.role === 1 ? (
          <Form.Group widths="equal">
            {/* <Form.Field error={!!errors.fullname}>
              <label htmlFor="fullname">Nombre completo</label>
              <input
                action={{
                  icon: "play",
                  onClick: () => this.handleClick(),
                }}
                className="u-full-width"
                type="text"
                placeholder=""
                id="fullname"
                name="fullname"
                disabled={this.props.role === 1 ? false : true}
                onChange={this.onChange}
                value={data.fullname}
              />
              {errors.fullname && <InlineError text={errors.fullname} />}
            </Form.Field> */}
            <Form.Field error={!!errors.fullname}>
              <label htmlFor="fullname">Nombre completo</label>
              <input
                className="u-full-width"
                type="text"
                placeholder=""
                id="fullname"
                name="fullname"
                disabled={this.props.role === 1 ? false : true}
                onChange={this.onChange}
                value={data.fullname}
              />
              {errors.fullname && <InlineError text={errors.fullname} />}
              <br></br>
              <input
                type="button"
                style={styles.checkFullnameButton}
                name="checkFullnameButton"
                id="checkFullnameButton"
                value="Validar nombre completo"
                onClick={() => this.handleCheckFullname(data.practitioner_id)}
              />
            </Form.Field>

            <Form.Field>
              <label htmlFor="approved">Habilitado</label>
              <Checkbox
                toggle
                name="approved"
                onChange={this._onChangeCheckbox}
                checked={data.approved === 1 ? true : false}
                floated="right"
              />
            </Form.Field>
          </Form.Group>
        ) : null}
        <Form.Group widths="equal">
          <Form.Field error={!!errors.birthdate}>
            <label htmlFor="birthdate">Fecha de nacimiento</label>
            <input
              className="u-full-width"
              type="date"
              placeholder=""
              id="birthdate"
              name="birthdate"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.birthdate}
            />
            {errors.birthdate && <InlineError text={errors.birthdate} />}
          </Form.Field>
          <Form.Field error={!!errors.gender}>
            <label htmlFor="gender">Género</label>
            <Form.Group inline>
              <Form.Field
                control={Radio}
                label="Femenino"
                name="genero"
                value={0}
                checked={data.gender === 0}
                onChange={this._onChangeRadioButton}
              />
              <Form.Field
                control={Radio}
                label="Masculino"
                name="genero"
                value={1}
                checked={data.gender === 1}
                onChange={this._onChangeRadioButton}
              />
            </Form.Group>
            {errors.gender && <InlineError text={errors.gender} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.email_address}>
            <label htmlFor="email_address">Correo Electrónico</label>
            <input
              className="u-full-width"
              type="email"
              placeholder=""
              id="email_address"
              name="email_address"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.email_address}
            />
            {errors.email_address && (
              <InlineError text={errors.email_address} />
            )}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.medical_record}>
            <label htmlFor="medical_record">Registro Médico</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="medical_record"
              name="medical_record"
              onChange={this.onChange}
              value={data.medical_record}
            />
            {errors.medical_record && (
              <InlineError text={errors.medical_record} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.specialty}>
            <label htmlFor="specialty">Especialidad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="specialty"
              name="specialty"
              onChange={this.onChange}
              value={data.specialty}
            />
            {errors.specialty && <InlineError text={errors.specialty} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          {" "}
          <Form.Field error={!!errors.city}>
            <label htmlFor="city">Ciudad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Ciudad de residencia"
              id="city"
              name="city"
              onChange={this.onChange}
              value={data.city}
            />
            {errors.city && <InlineError text={errors.city} />}
          </Form.Field>
          <Form.Field error={!!errors.address}>
            <label htmlFor="address">Dirección</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="address"
              name="address"
              onChange={this.onChange}
              value={data.address}
            />
            {errors.address && <InlineError text={errors.address} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.consulting_room}>
            <label htmlFor="consulting_room">Consultorio</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="consulting_room"
              name="consulting_room"
              onChange={this.onChange}
              value={data.consulting_room}
            />
            {errors.consulting_room && (
              <InlineError text={errors.consulting_room} />
            )}
          </Form.Field>
          <Form.Field error={!!errors.phone}>
            <label htmlFor="phone">Teléfono</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Teléfono fijo o celular"
              id="phone"
              name="phone"
              onChange={this.onChange}
              value={data.phone}
            />
            {errors.phone && <InlineError text={errors.phone} />}
          </Form.Field>
          
        </Form.Group>

        <Form.Group>
          <Form.Field>
            <label htmlFor="super_usuario">Super Usuario</label>
            <Checkbox
              toggle
              name="super_usuario"
              onChange={this._onChangeCheckbox}
              checked={data.super_usuario === 1 ? true : false}
              floated="right"
            />
          </Form.Field>
        </Form.Group>

        {/* {this.props.practitioner_id === this.props.loggedPractitioner ? (
          <div>
            <Form.Field>
              <label>Tratamiento de datos personales</label>
            </Form.Field>
          </div>
        ) : null} */}

        <Button
          floated="right"
          color="blue"
          content="Guardar"
          icon="save"
          labelPosition="right"
        />
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    id,
    practitioner_id,
    names,
    lastnames,
    fullname,
    email_address,
    username,
    medical_record,
    specialty,
    city,
    address,
    consulting_room,
    phone,
    super_usuario,
    birthdate,
    gender,
    approved,
  } = state.practitionerInfo.resp;
  const { role } = state.practitioner.resp;
  const { entities } = state.allEntitiesStore;

  return {
    practitioner_id: practitioner_id,
    names,
    lastnames,
    fullname,
    email_address,
    birthdate,
    username,
    medical_record: medical_record,
    specialty,
    city,
    address,
    consulting_room: consulting_room,
    phone,
    super_usuario,
    gender,
    approved,
    role,
    loggedPractitioner: state.practitioner.resp.practitioner_id,
    entities,
  };
  // }
};

export default connect(mapStateToProps, { fetchPractitionerAgreements })(
  EditForm
);
